<template>
  <ElDialog
    class="modal-dialog"
    :visible="isModalOpen"
    :title="modalData.title"
    lock-scroll
    v-bind="modalOptions"
    @close="closeModal"
  >
    <keep-alive>
      <component
        :is="modalData.component()"
        v-bind="modalData.props"
        :is-open="isModalOpen"
        @close="closeModal"
      />
    </keep-alive>
  </ElDialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  GLOBAL_MODAL_VISIBILITY,
  GLOBAL_MODAL_CLOSE,
  GLOBAL_MODAL_DATA,
  GLOBAL_MODAL_OPTIONS,
} from '@/store/types';

export default {
  name: 'ModalDialog',

  data() {
    return {
      visibility: false,
    };
  },

  computed: {
    ...mapGetters({
      isModalOpen: GLOBAL_MODAL_VISIBILITY,
      modalData: GLOBAL_MODAL_DATA,
      modalOptions: GLOBAL_MODAL_OPTIONS,
    }),
  },

  methods: {
    ...mapActions({
      closeModal: GLOBAL_MODAL_CLOSE,
    }),
  },
};
</script>

<style lang="scss">
.modal-dialog {
  .el-dialog__body {
    padding-bottom: 1rem;
    padding-top: 1rem;
  }
}
</style>
